module.exports = __webpack_public_path__ + "static/media/IPR-ru.b8d8eee5.PNG";